<template>
  <div class="owc-media-gallery-overlay__carousel-slide">
    <div class="owc-media-gallery-overlay__image">
      <VideoPlayer
        v-if="isVideo"
        :component-id="item.id"
        :class="`owc-media-gallery-overlay-item__${position}`"
        :datajson="JSON.stringify(item.json)"
      ></VideoPlayer>
      <GenericImage
        v-else
        :component-id="item.id"
        :class="`owc-media-gallery-overlay-item__${position}`"
        :imageData="item.json"
      ></GenericImage>
    </div>
    <div class="owc-media-gallery-overlay__container">
      <div class="owc-media-gallery-overlay__text-column">
        <h5 class="wb-type-copy-strong" v-html="title"></h5>
        <p class="wb-type-copy-secondary" v-if="description" v-html="description"></p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import VideoPlayer from '@owc-packages/VideoPlayer/src/VideoPlayer.vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import {
  MediaGalleryCarouselImage,
  MediaGalleryCarouselItem,
  MediaGalleryCarouselVideo,
  UnifiedFormat,
} from './MediaGalleryOverlay';
import { transformCarouselToUnifiedFormat, isCarouselItemAVideo } from './MediaGalleryOverlayUtils';
export default Vue.extend({
  name: 'owc-media-gallery-carousel-item',
  props: {
    item: {
      type: Object as () => MediaGalleryCarouselItem<MediaGalleryCarouselImage | MediaGalleryCarouselVideo>,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.$el instanceof HTMLElement) {
        mountFootnotes(this);
      }
    });
  },
  components: { VideoPlayer, GenericImage },
  computed: {
    mediaGalleryCarouselItem(): UnifiedFormat {
      return transformCarouselToUnifiedFormat(this.item);
    },
    title(): string {
      return this.mediaGalleryCarouselItem.title;
    },
    description(): string | undefined {
      return this.mediaGalleryCarouselItem.description;
    },
    isVideo(): boolean {
      return isCarouselItemAVideo(this.item);
    },
  },
});
</script>
<style lang="scss">
.owc-media-gallery-overlay {
  &__image {
    position: relative;
  }
  &__text-column {
    @include wb-content-width;

    margin-bottom: var(--wb-spacing-l);

    @include breakpoint-from(mq4) {
      width: auto;
      margin-bottom: 0;
    }

    .wb-type-copy-strong {
      margin-top: var(--wb-spacing-m);

      @include breakpoint-from(mq4) {
        margin-top: var(--wb-spacing-xs);
      }
    }
    .wb-type-copy-secondary {
      margin-top: var(--wb-spacing-xs);

      @include breakpoint-from(mq4) {
        margin-top: var(--wb-spacing-xxs);
      }
    }
  }
}
</style>
